import { app } from '../../game/app';
import { Container } from '../../odie';

import {
  TabControllerClass,
  TabDef,
  TabNav,
  TabScreenClass,
} from '../../odie/plugins/nav/TabNav';
import { BasicTabButton } from './BasicTabButton';

// types
//-----------------------------------------------------------------------------
export type BasicTabDef = {
  text: string;
  screen: TabScreenClass;
  controller?: TabControllerClass;
  options?: Record<string, unknown>;
};

export type BasicTabMenuOptions = {
  width: number;
  height: number;
  color: number;
  border: number;
  spacing: number;
  alpha: number;
  firstTab: number;
  tabs: BasicTabDef[];
};

/*
    base tab menu
*/
export class BasicTabMenu extends Container {
  // fields
  //-------------------------------------------------------------------------
  // scene
  private _container!: Container;
  // components
  private readonly _controller: TabNav;

  // properties
  //-------------------------------------------------------------------------
  public get tab(): number {
    return this._controller.tab;
  }

  public get controller(): TabNav {
    return this._controller;
  }

  // init
  //-------------------------------------------------------------------------
  constructor(options: BasicTabMenuOptions) {
    super();

    // spawn buttons and get tab defs
    const tabs = this._spawnButtons(options);

    // spawn container
    this._spawnContainer(options);

    // create controller
    this._controller = new TabNav({
      app,
      tabs,
      container: this._container,
    });

    this.controller.setTab(options.firstTab);
  }

  public static assets(): string[] {
    return BasicTabButton.assets();
  }

  // private: scene
  //---------------------------------------------------------------------------
  private _spawnButtons(options: BasicTabMenuOptions): TabDef[] {
    const hBorderSize = options.border / 2;
    let x = -hBorderSize; // for each basic tab def

    return options.tabs.map((basicTabDef) => {
      // create button
      const button = new BasicTabButton({
        text: basicTabDef.text,
        width: 175,
        height: 50,
      });
      button.y = hBorderSize;
      button.x = x;
      x += button.width + options.spacing;

      // spawn button
      this.addChild(button);

      // create tab def
      return {
        button,
        screen: basicTabDef.screen,
        controller: basicTabDef.controller,
        options: basicTabDef.options,
      };
    });
  }

  private _spawnContainer(options: BasicTabMenuOptions) {
    this._container = new Container();

    this._container.width = options.width;
    this._container.height = options.height;

    this._container.x = 0;
    this._container.y = 52;
    this.addChild(this._container);
  }
}
